import { useEffect } from "react";
import { useDispatch } from 'react-redux';
import { setYoutubeVideo, setGoogleClientId } from '../../store/slices/configSlice';
import { getYoutubeVideo, getGoogleClientId } from "../../services/utilService";

const Utilities = () => {
    const dispatch = useDispatch();

    useEffect(()=>{
        getYoutubeVideo()
            .then(rsp => {
                if (rsp.code === '00')
                    dispatch(setYoutubeVideo(rsp.metadata));
            });
        
        
        getGoogleClientId()
            .then(rsp => {
                if (rsp.code === '00')
                    dispatch(setGoogleClientId(rsp.metadata));
            })
    }, [])
};

export default Utilities;